import React, { useEffect } from "react";
import "./Advantage1.css";
import num1dark from "../images/num1-dark.png";

const Advantage1 = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          }
        });
      },
      { threshold: 0.15 }
    );

    const elements = document.querySelectorAll(".advantage1-1 .animate-side");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="advantage1-1">
      <div className="advantage1-2">
        <div className="img1-1 animate-side slide-left">
          <div
            className="logo-light"
            style={{
              backgroundImage: `url(${num1dark})`,
            }}
          />
        </div>
        <div className="advantage1-content animate-side slide-right">
          <h1>Complete All-in-One Ecosystem</h1>
          <div className="advantage1-3">
            <p>
              <label>Unified Management:</label>
              Eliminate vendor friction by bringing web design, POS, ERP, and mobile systems under one integrated roof.<br/>
              <label>Seamless Data Sync:</label>
              Real-time synchronization between physical POS terminals, online stores, and back-office inventory.<br/>
              <label>End-to-End Reliability:</label>
              Every software touchpoint is designed to work together without complex custom middleware or broken API connectors.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Advantage1;